(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sshop-product-information"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll(".sshop-pi").forEach(function (root) {
    if (root.dataset.sshopPiInit === "1") return;
    root.dataset.sshopPiInit = "1";

    var main = root.querySelector("[data-sshop-pi-main]");
    root.querySelectorAll("[data-sshop-pi-thumb]").forEach(function (t, i) {
      if (i === 0) t.classList.add("is-on");
      t.addEventListener("click", function () {
        if (main) main.src = t.getAttribute("data-sshop-pi-thumb");
        root.querySelectorAll("[data-sshop-pi-thumb]").forEach(function (o) { o.classList.remove("is-on"); });
        t.classList.add("is-on");
      });
    });

    var idInput = root.querySelector("[data-sshop-pi-id]");
    // Blocks that follow the variant (stock, sticky bar, buy button) listen to
    // the form's own id field, so a change there has to be announced.
    var announce = function () {
      if (idInput) idInput.dispatchEvent(new Event("change", { bubbles: true }));
    };

    root.querySelectorAll("[data-sshop-pi-v]").forEach(function (b) {
      b.addEventListener("click", function () {
        root.querySelectorAll("[data-sshop-pi-v]").forEach(function (o) { o.classList.remove("is-on"); });
        b.classList.add("is-on");
        if (idInput) idInput.value = b.getAttribute("data-sshop-pi-v");
        var name = root.querySelector("[data-sshop-pi-vname]");
        if (name) name.textContent = b.getAttribute("data-sshop-pi-vtitle");
        var price = root.querySelector("[data-sshop-pi-price]");
        if (price) price.textContent = b.getAttribute("data-sshop-pi-vprice");
        announce();
      });
    });

    // One choice per option: the variant is whichever matches all of them.
    var opts = root.querySelector("[data-sshop-pi-opts]");
    if (!opts) return;
    var variants = [];
    try { variants = JSON.parse(opts.querySelector("[data-sshop-pi-variants]").textContent); } catch (e) { return; }
    var sets = Array.prototype.slice.call(opts.querySelectorAll("[data-sshop-pi-opt]"));
    var add = root.querySelector(".sshop-pi__add");
    var now = root.querySelector("[data-sshop-pi-now]");
    var was = root.querySelector("[data-sshop-pi-was]");
    var off = root.querySelector("[data-sshop-pi-off]");

    var chosen = function () {
      return sets.map(function (set) {
        var on = set.querySelector(".is-on");
        return on ? on.getAttribute("data-value") : null;
      });
    };
    var matches = function (variant, pick) {
      return variant.o.every(function (value, i) { return value === pick[i]; });
    };
    var mark = function (pick) {
      sets.forEach(function (set, i) {
        set.querySelectorAll("[data-value]").forEach(function (b) {
          var trial = pick.slice();
          trial[i] = b.getAttribute("data-value");
          var open = variants.some(function (variant) { return variant.a && matches(variant, trial); });
          b.classList.toggle("is-gone", !open);
        });
      });
    };
    var sync = function () {
      var pick = chosen();
      var hit = variants.filter(function (variant) { return matches(variant, pick); })[0];
      mark(pick);
      if (!hit) return;
      if (idInput) idInput.value = hit.id;
      if (now) now.textContent = hit.p;
      if (was) { was.textContent = hit.c; was.hidden = !hit.c; }
      if (off) {
        off.textContent = off.getAttribute("data-words") === "save"
          ? off.getAttribute("data-save") + " " + hit.d + "%"
          : "-" + hit.d + "%";
        off.hidden = !hit.d;
      }
      if (add) {
        add.disabled = !hit.a;
        add.textContent = hit.a ? add.getAttribute("data-label") : add.getAttribute("data-sold");
        if (hit.a && add.getAttribute("data-show-price") === "true") {
          var price = document.createElement("span");
          price.setAttribute("data-sshop-pi-price", "");
          price.textContent = hit.p;
          add.appendChild(document.createTextNode(" • "));
          add.appendChild(price);
        }
      }
      announce();
    };

    opts.addEventListener("click", function (e) {
      var b = e.target.closest("[data-value]");
      if (!b || !opts.contains(b)) return;
      var set = b.closest("[data-sshop-pi-opt]");
      set.querySelectorAll("[data-value]").forEach(function (o) {
        o.classList.remove("is-on");
        o.setAttribute("aria-pressed", "false");
      });
      b.classList.add("is-on");
      b.setAttribute("aria-pressed", "true");
      var label = set.querySelector("[data-sshop-pi-optname]");
      if (label) label.textContent = b.getAttribute("data-value");
      sync();
    });
    mark(chosen());
  });
})();

  } catch(e) { console.error(e); }
})();
})();
